<template>
  <v-container class="mt-5" style="height: 100vh">
    <v-card flat class="rounded-xl">
      <v-data-table
        height="70vh"
        :items-per-page="-1"
        rounded
        fixed-header
        :headers="headers"
        :items="items"
        item-key="id"
        sort-by="id"
        class="elevation-0 pt-4 mb-10"
      >
        <template v-slot:top>
          <div class="d-flex align-center full-width flex-wrap">
            <v-chip
              :color="editedDomain === domain.value ? 'primary white--text' : ''"
              @click="editedDomain = domain.value"
              v-for="domain in editableDomains"
              :key="domain.value"
              class="pa-4 ma-2"
              >{{ domain.text }}
            </v-chip>

            <v-dialog v-model="dialog" max-width="500px">
              <v-card @keydown.enter="save">
                <v-card-title>
                  <span class="text-h5">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row v-if="headers.find((h) => h.value === 'short')">
                      <v-col cols="12">
                        <v-text-field autofocus v-model="editedItem.short" placeholder="Kürzel erfassen" clearable label="Text"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="headers.find((h) => h.value === 'year')">
                      <v-col cols="12">
                        <v-text-field autofocus type="Number" v-model="editedItem.year" placeholder="Jahr erfassen" clearable label="Jahr"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="headers.find((h) => h.value === 'month')">
                      <v-col cols="12">
                        <v-text-field
                          autofocus
                          type="Number"
                          v-model="editedItem.month"
                          placeholder="Monat erfassen (1=Januar, etc.)"
                          clearable
                          label="Monat"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="headers.find((h) => h.value === 'hours')">
                      <v-col cols="12">
                        <v-text-field
                          autofocus
                          type="Number"
                          v-model="editedItem.hours"
                          placeholder="Monatssoll in Stunden erfassen"
                          clearable
                          label="Stundensoll Monat"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" v-if="editedDomain !== 'zueri9MonthlyExpectedHour'">
                        <v-text-field autofocus v-model="editedItem.text" placeholder="Text erfassen" clearable label="Text"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="headers.find((h) => h.value === 'bgColor')">
                      <v-col cols="12">
                        Farbe
                        <color-palette-picker v-model="editedItem.bgColor" :text="editedItem.text"></color-palette-picker>
                      </v-col>
                    </v-row>
                    <v-row v-if="headers.find((h) => h.value === 'systemValue')">
                      <v-col cols="12">
                        Systemwert
                        <div>{{ editedItem.systemValue }}</div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close"> Abbrechen</v-btn>
                  <v-btn color="primary" text @click="save"> Speichern</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5">Wollen Sie diesen Eintrag wirklich löschen?</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="closeDelete">Abbrechen</v-btn>
                  <v-btn color="primary" text @click="deleteItemConfirm">OK</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <template v-slot:[`item.bgColor`]="{ item }">
          <div class="white--text" :style="{ background: item ? item.bgColor : '' }">{{ item.bgColor }}</div>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn outlined rounded icon color="primary" class="mr-1" @click="editItem(item)"><v-icon small> mdi-pencil</v-icon></v-btn>
          <v-btn outlined rounded icon :disabled="item.system === true" color="primary" @click="deleteItem(item)"><v-icon small> mdi-delete</v-icon></v-btn>
        </template>
        <template v-slot:footer v-if="operationResponse.status === 'ERROR'">
          <v-alert dense type="error"> {{ operationResponse.userMsg }}</v-alert>
        </template>
        <template v-slot:no-data> keine Daten vorhanden</template>
      </v-data-table>
      <v-btn
        color="primary"
        style="position: absolute; bottom: 40px; right: 40px"
        fab
        rounded
        class="ml-3 mb-2"
        @click="
          editedItem = {};
          dialog = true;
        "
        ><v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import MODULE_ID from '../moduleId';
import { mapState, mapMutations } from 'vuex';
import index from '@/modules/customerVbzWorksheet';
import configMixin from '@/mixins/configMixin';
import ColorPalettePicker from '@/modules/customerVbzWorksheet/components/ColorPalettePicker.vue';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
// the attrbute viewRestrictionGroupId references the department id (e.g. zueri9) in ui-config.modules[0].viewRestrictedToOneOfGroup
// To edit a domain the user must be part of the restricted groups for. Example: To see zueri9 items the user
// needs to be within at least one of the groups listed in viewsRestrictedToOneOfGroup.zueri9
const editableDomains = [
  { value: 'reason', text: 'Grund', viewRestrictionGroupId: 'dispo' },
  { value: 'illnessReason', text: 'Krankheitsgrund', viewRestrictionGroupId: 'dispo' },
  { value: 'remark', text: 'Bemerkung', viewRestrictionGroupId: 'dispo' },
  { value: 'betriebshof', text: 'Betriebshof', viewRestrictionGroupId: 'dispo' },
  { value: 'absenceDuration', text: 'Dauer der Abwesenheit', viewRestrictionGroupId: 'dispo' },
  { value: 'zueri9Client', text: 'Für wen', viewRestrictionGroupId: 'zueri9' },
  { value: 'zueri9Reason', text: 'Was', viewRestrictionGroupId: 'zueri9' },
  { value: 'dispoState', text: 'Dispo Status', viewRestrictionGroupId: 'dispo' },
  { value: 'zueri9State', text: 'Zueri9 Status', viewRestrictionGroupId: 'zueri9' },
  { value: 'zueri9MonthlyExpectedHour', text: 'Zueri9 monatliches Stundensoll', viewRestrictionGroupId: 'zueri9' },
];
const headers = [
  {
    text: 'Id',
    align: 'start',
    sortable: true,
    value: 'id',
  },
  {
    text: 'Kürzel',
    restrictedToDomains: ['zueri9Client', 'zueri9Reason'],
    align: 'start',
    sortable: true,
    value: 'short',
  },
  {
    text: 'Text',
    restrictedToDomains: ['reason', 'illnessReason', 'remark', 'betriebshof', 'absenceDuration', 'dispoState', 'zueri9State', 'zueri9Client', 'zueri9Reason'],

    align: 'start',
    sortable: true,
    value: 'text',
  },
  {
    text: 'Jahr',
    restrictedToDomains: ['zueri9MonthlyExpectedHour'],
    align: 'right',
    sortable: true,
    value: 'year',
  },
  {
    text: 'Monat',
    restrictedToDomains: ['zueri9MonthlyExpectedHour'],
    align: 'right',
    sortable: true,
    value: 'month',
  },
  {
    text: 'Soll h (100h wenn nichts angegeben)',
    restrictedToDomains: ['zueri9MonthlyExpectedHour'],
    align: 'right',
    sortable: true,
    value: 'hours',
  },
  {
    text: 'Farbe',
    restrictedToDomains: ['dispoState', 'zueri9State'],
    align: 'center',
    sortable: true,
    value: 'bgColor',
  },
  {
    text: 'Bedeutung System',
    restrictedToDomains: ['dispoState', 'zueri9State'],
    align: 'center',
    sortable: false,
    value: 'systemValue',
  },

  { text: 'Aktionen', value: 'actions', sortable: false },
];
export default {
  components: { ColorPalettePicker },
  mixins: [configMixin, wsMixin],
  beforeUpdate() {
    //setTimeout(() => {
    console.debug('make sure, the room is joined.');
    this.$socket.emit('join-room', { room: 'vbzWorksheet' }, (response) => {
      console.debug(`join-room response: Status=${response.status} Message=${response.msg}`);
    });
    // }, 10000);
  },

  data: () => ({
    editedDomain: 'reason',

    operationResponse: {},
    dialog: false,
    dialogDelete: false,

    //items: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {
      text: '',
    },
  }),

  computed: {
    ...mapState('profile', ['user']),
    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    editableDomains() {
      let viewsRestrictedToOneOfGroup = this.moduleConfig.viewsRestrictedToOneOfGroup;

      return editableDomains.filter((d) => {
        let permissionedGroups = viewsRestrictedToOneOfGroup[d.viewRestrictionGroupId];
        if (!permissionedGroups) return false;

        let groupInRequiredGroups = permissionedGroups.find((group) => this.user.groups.includes(group));
        return !!groupInRequiredGroups;
      });
    },
    formTitle() {
      return this.editedIndex === -1 ? 'Neuer Eintrag' : 'Eintrag editieren';
    },
    items() {
      return this.$store.state[`${MODULE_ID}`][`${this.editedDomain}s`].slice().sort((a, b) => (a.id - b.id < 0 ? -1 : 1));
    },
    headers() {
      return headers.filter((h) => {
        if (h.restrictedToDomains) {
          return h.restrictedToDomains.includes(this.editedDomain);
        }
        return true;
      });
    },
  },

  methods: {
    ...mapMutations(MODULE_ID, ['pushDomainItem', 'saveDomainItems', 'updateItem']),
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = item; //Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      console.debug('deleteItem', item);
      // this.editedIndex = this.items.indexOf(item);
      this.editedItem = item; //Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.$socket.emit('domain:delete', this.editedDomain, this.editedItem, (response) => {
        this.operationResponse = response;
        if (response.status === 'OK') {
          console.debug('items', this.items);
          console.debug('editedItem', this.editedItem);
          let ind = this.items.findIndex((item) => item.id === this.editedItem.id);
          // this.items.splice(this.editedIndex, 1);
          console.debug(`deleteItem item=${JSON.stringify(this.editedItem, null, 2)}, id=${this.editedItem.id} index=${ind}`);
          let cleansedItems = this.items.toSpliced(ind, 1);
          this.saveDomainItems({ domain: this.editedDomain, items: cleansedItems });
        } else if (response.status === 'ERROR' && response.type === 'DELETE_FAILED_SINCE_REFERENCES_AVAILABLE') {
          this.operationResponse.userMsg = 'Der Eintrag konnte nicht gelöscht werden, da dieser benutzt wird.';
        }
      });
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        // this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        // this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        let itemAtIndex = this.items[this.editedIndex];
        this.$socket.emit('domain:update', this.editedDomain, this.editedItem, (response) => {
          // Object.assign(itemAtIndex, response.data);
          this.updateItem({ oldItem: this.editedItem, newItem: response.data });
          this.close();
        });
      } else {
        this.$socket.emit('domain:create', this.editedDomain, this.editedItem, (response) => {
          console.debug(`domain:create ${this.editedDomain} response:${response.data}`);
          this.pushDomainItem({ domain: this.editedDomain, item: response.data });
          // this.items.push(response.data);
          this.close();
        });
      }
    },
  },
  watch: {
    operationResponse(newValue, oldValue) {
      setTimeout(() => {
        this.operationResponse = {};
      }, 10000);
    },
  },
};
</script>
<style>
.selected-color {
  border: 4px solid white !important;
}
</style>
